define('SuiteCommerce.ItemBadges.EntryPoint', [
  'SuiteCommerce.ItemBadges.Collection',
  'SuiteCommerce.ItemBadges.ProductDetail',
  'SuiteCommerce.ItemBadges.ProductList',
  'SuiteCommerce.ItemBadges.GlobalViews',
  'SuiteCommerce.ItemBadges.Instrumentation.InstrumentationHelper',
  'SuiteCommerce.ItemBadges.Configuration'
], function ItemBadgesEntryPoint(
  ItemBadgesCollection,
  ItemBadgesProductDetail,
  ItemBadgesProductList,
  ItemBadgesGlobalViews,
  InstrumentationHelper,
  Configuration
) {
  'use strict';

  return {
    mountToApp: function mountToApp(application) {
      var log = InstrumentationHelper.initialize(application);
      Configuration.initialize(application);
      var collection = new ItemBadgesCollection();
      var collectionPromise;
      ItemBadgesProductDetail.loadProductDetailItemBadges(application, collection);
      ItemBadgesProductList.loadProductListItemBadges(application, collection);
      ItemBadgesGlobalViews.loadGlobalViewsItemBadges(application, collection);
      collectionPromise = collection.fetch();
      this.registerFetchTimer(collectionPromise);
    },

    registerFetchTimer: function registerFetchTimer(collectionPromise) {
      var fetchTimer = InstrumentationHelper.getLog('fetchTimer');
      fetchTimer.startTimer();
      collectionPromise.done(function promiseDone() {
        fetchTimer.endTimer();
        fetchTimer.setParametersToSubmit({
          componentArea: 'SC Item Badges',
          activity: 'Fetch Timer',
          totalTime: fetchTimer.getElapsedTimeForTimer()
        });
        fetchTimer.submit();
      });
    }
  };
});
